export default __webpack_public_path__ + "static/blob-dog-e4ce21bbe2e7e1a09ccde9830d2fc8e9.png";